import React from "react";
const PrivacyPolicy = () => {
  return (
    <article className="mx-auto max-w-3xl px-4 py-8 text-mauve-900">
      <h1 className="mb-6 text-center text-3xl font-semibold text-mauve-900">
        Privacy Policy
      </h1>

      <p>
        <strong>Effective Date:</strong> January 1st, 2025
      </p>
      <p>
        <strong>Last Updated:</strong> July 21st, 2026
      </p>

      <p>
        Welcome to <strong>FaveBack</strong> (
        <a
          href="https://faveback.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://faveback.com
        </a>
        ). Your privacy is important to us. This Privacy Policy explains how we
        collect, use, and protect your data while complying with the{" "}
        <strong>General Data Protection Regulation (GDPR).</strong>
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        1. Data We Collect
      </h3>
      <p>We collect the following types of information:</p>
      <ul>
        <li>
          <strong>Account Information:</strong> Your email and other details
          when signing up.
        </li>
        <li>
          <strong>Request Data:</strong> Titles, recipient email addresses, and
          filenames (not actual image files) related to selection requests and
          client picks.
        </li>
        <li>
          <strong>Log Data:</strong> IP addresses, browser types, and website
          interactions for security and analytics.
        </li>
        <li>
          <strong>Cookies & Tracking:</strong> We use cookies for session
          management and analytics. You can disable cookies in your browser
          settings.
        </li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        2. How We Use Your Data
      </h3>
      <ul>
        <li>To provide and maintain FaveBack services.</li>
        <li>To send transactional emails related to selection requests.</li>
        <li>To improve security and prevent fraud.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        3. GDPR Compliance & Your Rights
      </h3>
      <p>Under GDPR, users in the European Union have the following rights:</p>
      <ul>
        <li>
          <strong>Right to Access:</strong> Request a copy of the data we hold
          about you.
        </li>
        <li>
          <strong>Right to Rectification:</strong> Request corrections to
          inaccurate or incomplete data.
        </li>
        <li>
          <strong>Right to Erasure:</strong> Request deletion of your personal
          data when legally applicable.
        </li>
        <li>
          <strong>Right to Restrict Processing:</strong> Request that we limit
          how we use your data.
        </li>
        <li>
          <strong>Right to Data Portability:</strong> Receive your personal data
          in a structured format.
        </li>
        <li>
          <strong>Right to Object:</strong> Object to data processing based on
          legitimate interests.
        </li>
      </ul>
      <p>
        To exercise your rights, contact us at{" "}
        <strong>gdpr@faveback.com</strong>
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        4. Data Sharing & Storage
      </h3>
      <p>We do not sell your personal data. We may share data with:</p>
      <ul>
        <li>Third-party service providers (e.g., email services).</li>
        <li>Authorities if required by law.</li>
      </ul>
      <p>
        Your data is stored securely and retained only as long as necessary for
        our services.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        5. Data Security
      </h3>
      <p>
        We implement industry-standard security measures to protect your data.
        However, no system is 100% secure.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        6. Cookies & Tracking
      </h3>
      <p>
        FaveBack uses cookies for authentication and analytics. You can manage
        cookie settings in your browser.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        7. Changes to This Policy
      </h3>
      <p>
        We may update this Privacy Policy. The latest version will always be
        available on this page.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        8. Contact Us
      </h3>
      <p>
        If you have any questions, contact us at{" "}
        <strong>support@faveback.com</strong>
      </p>
    </article>
  );
};

export default PrivacyPolicy;
